// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"07ded678","611":"2fe5a35f","761":"08421ba3","947":"4cf2bd87"}[chunkId] + ".chunk.js";
};